import { AddressPickerConstants } from '../constants/actions';

export const setDeliveryPickedAddress = () => ({
  type: `${AddressPickerConstants.SET_DELIVERY_ADDRESS}_REQUEST`
});
